import React from 'react';
import GrayTick from '../../../assets/icons/grayTick.png';

interface IViewInformationPills {
  text: string;
}

const ViewInformationPills = ({ text }: IViewInformationPills) => {
  return (
    <div className="m-1.5 inline-flex h-8 items-center rounded-full bg-[#f2f2f2] px-3 py-1.5 text-sm font-normal leading-5 text-[#505054]">
      <img src={GrayTick} alt="" className="mr-1.5 h-[13px] w-[15px]" />
      {text}
    </div>
  );
};

export default ViewInformationPills;
